import { jsx } from "react/jsx-runtime";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import styles from "./BenefitsTooltip.module.scss.js";
function BenefitsTooltipTitle({ title }) {
  return /* @__PURE__ */ jsx(Typography.Text, { level: "h4", color: "darkest", className: styles.benefitsTooltipTitle, children: title });
}
export {
  BenefitsTooltipTitle
};
